import React, { useEffect, useMemo, useState } from "react";
import { Participants, Votes } from "../../../pages";
import { CompetitionController } from "../../../controllers";

const ParticipantsContainer = () => {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [competition, setCompetition] = useState("");
  const [stage, setStage] = useState("");
  const [updateParticipantModal, setUpdateParticipantModal] = useState(false);
  const [createVotesModal, setCreateVotesModal] = useState(false);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [participantsTableQuery, setParticipantsTableQuery] = useState({
    offset: 0,
    limit: limit,
  });

  const onSubmit = async (values) => {
    setLoading(true);
    setParticipantsTableQuery({
      offset: currentPage + 1,
      limit: limit,
      ...(values.competition?.key && { competition: values.competition.key }),
      ...(values.stage && { stage: values.stage }),
    });

    return setLoading(false);
  };

  const { isLoading, data, isFetching } =
    CompetitionController.useGetParticipants(participantsTableQuery);

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToUpdateParticipantModal = () => {
    setUpdateParticipantModal(true);
  };
  const goToCreateVotesModal = () => {
    setCreateVotesModal(true);
  };
  const goToViewMoreModal = () => {
    setViewMoreModal(true);
  };

  const closeModal = () => {
    setSelectedIndex(-1);
    setUpdateParticipantModal(false);
    setCreateVotesModal(false);
    setViewMoreModal(false);
  };

  return (
    <Participants
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      setCompetition={setCompetition}
      setStage={setStage}
      onSubmit={onSubmit}
      loading={loading}
      updateParticipantModal={updateParticipantModal}
      goToUpdateParticipantModal={goToUpdateParticipantModal}
      closeModal={closeModal}
      selectedIndex={selectedIndex}
      setSelectedIndex={setSelectedIndex}
      createVotesModal={createVotesModal}
      goToCreateVotesModal={goToCreateVotesModal}
      goToViewMoreModal={goToViewMoreModal}
      viewMoreModal={viewMoreModal}
    />
  );
};

export default ParticipantsContainer;
